import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router';
import blogimage from '../../assets/image/blogimage.png'
import {
    FaEye,
    FaEdit,
    FaTrash,
    FaRegNewspaper
} from 'react-icons/fa';
import { useDispatch } from "react-redux";

import { openModal } from "../../redux/features/modalSlice";
function Allblog() {
const dispatch=useDispatch()
const navigate = useNavigate()
    const [blogData, setBlogData] = useState([
        {
            id: 1,
            title: 'Top 10 Luxury Hotels in Jaipur',
            category: 'Travel',
            author: 'Admin',
            date: '12 May 2026',
            status: 'Published',
            blogimage: blogimage
        },
        {
            id: 2,
            title: 'Best Swimming Pool Amenities',
            category: 'Hotel',
            author: 'Rohit',
            date: '10 May 2026',
            status: 'Draft',
            blogimage: blogimage
        },
        {
            id: 3,
            title: 'How to Improve Hotel Booking',
            category: 'Business',
            author: 'Admin',
            date: '08 May 2026',
            status: 'Published',
            blogimage: blogimage
        }
    ]);


    return (
        <div>

            {/* PAGE HEADER */}
            <div className="d-md-flex d-block align-items-center justify-content-between  page-header-breadcrumb">

                <div className="ms-md-1 mb-1 mb-md-0 ms-0 page_heading_breadcrumb">

                    <nav>

                        <h4 className="fw-semibold">
                            All Blogs
                        </h4>

                        <ol className="breadcrumb mb-0">

                            <li className="breadcrumb-item">
                                <Link to="/">
                                    Home
                                </Link>
                            </li>

                            <li
                                className="breadcrumb-item active"
                                aria-current="page"
                            >
                                All Blogs
                            </li>

                        </ol>

                    </nav>

                </div>

                <div className="page-title fw-semibold fs-18 mb-0">

                    <Link
                        to="/add-blog"
                        className="btn btn-primary"
                    >
                        Add Blog
                    </Link>

                </div>

            </div>

            {/* TABLE CARD */}
            <div className="st-wrapper-card">

                <div className="st-table-responsive">

                    <table className="table st-custom-table align-middle mb-0">

                        <thead>

                            <tr>
                                <th>ID</th>
                                <th>Image</th>
                                <th>Blog</th>
                                <th>Category</th>
                                <th>Author</th>
                                <th>Date</th>
                                <th> Change Status</th>
                                <th>Status</th>
                                <th className="text-center">
                                    Action
                                </th>
                            </tr>

                        </thead>

                        <tbody>

                            {
                                blogData.map((item) => (

                                    <tr key={item.id}>

                                        <td>
                                            #{item.id}
                                        </td>

                                        {/* BLOG */}
                                        <td>
                                            <div className="blogimage">
                                                <img src={item.blogimage} width={50} alt={item.blogimage} />
                                            </div>
                                        </td>
                                        <td>

                                            <div className="blog-info-box">


                                                <div>

                                                    <h6>
                                                        {item.title}
                                                    </h6>

                                                </div>

                                            </div>

                                        </td>

                                        {/* CATEGORY */}
                                        <td>
                                            {item.category}
                                        </td>

                                        {/* AUTHOR */}
                                        <td>
                                            {item.author}
                                        </td>

                                        {/* DATE */}
                                        <td>
                                            {item.date}
                                        </td>
                                        <td></td>
                                        {/* STATUS */}
                                        <td>

                                            <span
                                                className={
                                                    item.status === 'Published'
                                                        ? 'blog-status published'
                                                        : 'blog-status draft'
                                                }
                                            >

                                                {item.status}

                                            </span>

                                        </td>

                                        {/* ACTION */}
                                        <td className="text-center">

                                            {/* VIEW */}
                                            <button
                                                className="st-action-btn st-view-btn"
                                                onClick={() =>
                                                    dispatch(
                                                        openModal({
                                                            type: "view-blog",
                                                            title: "Blog Details",
                                                            data: item,
                                                        })
                                                    )
                                                }
                                            >
                                                <FaEye />
                                            </button>

                                            {/* EDIT */}
                                            <button
                                                className="st-action-btn st-edit-btn"
                                                onClick={() =>
                                                    dispatch(
                                                        openModal({
                                                            type: "edit-blog",
                                                            title: "Edit Blog",
                                                            data: item,
                                                        })
                                                    )
                                                }
                                            >
                                                <FaEdit />
                                            </button>

                                            {/* DELETE */}
                                            <button
                                                className="st-action-btn st-delete-btn"
                                                onClick={() =>
                                                    dispatch(
                                                        openModal({
                                                            type: "delete-blog",
                                                            title: "Delete Blog",
                                                            data: item,
                                                        })
                                                    )
                                                }
                                            >
                                                <FaTrash />
                                            </button>

                                        </td>

                                    </tr>

                                ))
                            }

                        </tbody>

                    </table>

                </div>

            </div>

      

        </div>
    );
}

export default Allblog; 